<template>
  <div id="markerSearchBox">
    <!-- 下拉框 -->
    <el-select class="dataTypeSelect" v-model="selectedDataType" placeholder="请选择数据类型" @change="handleDataTypeChange">
      <el-option v-for="item in dataTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
    <!-- 带输入建议的输入框 -->
    <el-autocomplete class="searchSelectData" v-model="inputValue" :fetch-suggestions="querySearch" placeholder="请输入内容" @select="handleSelect"></el-autocomplete>
    <el-button class="backCenterBtn" @click="backCenter()">回中心</el-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { deepClone } from '@/utils';
import { getMap } from '@/utils/mainMap2.js';

export default {
  name: 'MarkerSearchBox',
  data() {
    return {
      selectedDataType: '',
      dataTypes: [
        { value: 'type1', label: '应急救援大队' },
        { value: 'type2', label: '应急仓库' },
        { value: 'type3', label: '应急救援车辆' }
      ],
      inputValue: '',
      suggestions: [] // 输入建议数据
    };
  },
  computed: {
    ...mapState('bi', ['stashInfo', 'teamInfo'])
  },
  mounted() {

  },
  methods: {
    ...mapActions('bi', ['getDeviceLocation']),
    async handleDataTypeChange(value) {
      this.inputValue = '';
      this.backCenter();
      switch (value) {
        case 'type1':
          this.suggestions = this.sortingPointsData(this.teamInfo);
          window.labelsLayer.show();
          window.polygonLayer.show();
          this.closeCarMarkerLayer();
          break;
        case 'type2':
          this.suggestions = this.sortingPointsData(this.stashInfo);
          window.labelsLayer.show();
          window.polygonLayer.show();
          this.closeCarMarkerLayer();
          break;
        case 'type3':
          await this.fetchDeviceListData();
          this.openCarMarkerLayer();
          break;
      }
    },
    async fetchDeviceListData() {
      try {
        const fnData = {
          pageNumber: 1,
          pageSize: 10,
          keyword: ''
        };
        await this.$store.dispatch('bi/getDeviceList', fnData);
        if (this.$store.state.bi.deviceList) {
          await this.getDeviceListFn();
        } else {
          console.log('数据请求失败或未获取到数据');
        }
      } catch (err) {
        console.log('请求出错', err);
      }
    },
    // 获取设备列表
    async getDeviceListFn() {
      const deviceList = this.$store.state.bi.deviceList.dataList;
      const deviceNoList = deepClone(deviceList).map((item) => item.deviceNo);
      await this.getDeviceLocationData({ deviceNoList }); // 获取设备实时定位信息列表
      this.suggestions = this.sortingPointsData(deviceList);
      this.$store.commit('bi/SET_CARMARKERINFO', this.suggestions); // 将处理后的汽车信息保存到state
    },
    // 获取设备实时定位
    async getDeviceLocationData({ carNolist, deviceNoList, returnCoord = 'GCJ-02' } = {}) {
      await this.getDeviceLocation({ carNolist, deviceNoList, returnCoord });
    },
    // 带输入建议的input
    querySearch(queryString, cb) {
      const queryDataList = this.suggestions;
      const results = queryString ? this.createFilter(queryDataList, queryString) : queryDataList;
      // 获取输入建议的逻辑
      cb(deepClone(results));
    },
    createFilter(queryDataList, queryString) {
      return queryDataList.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase()));
    },
    sortingPointsData(dataList) {
      let sortDataArr = null;
      const _selectedDataType = this.selectedDataType;
      if (_selectedDataType === 'type3') {
        const deviceLocationData = deepClone(this.$store.state.bi.deviceLocations);
        const _sortDataArr = dataList.map((item) => ({
          id: item.deviceId,
          value: item.deviceNo
        }));
        sortDataArr = _sortDataArr.map((item) => {
          const matchedItem = deviceLocationData.find((deviceLocationItem) => deviceLocationItem.deviceId === item.id);
          if (matchedItem) {
            return {
              ...item,
              lon: matchedItem.x,
              lat: matchedItem.y
            };
          }
          return item;
        });
        return deepClone(sortDataArr);
      } else if (_selectedDataType === 'type2') {
        sortDataArr = dataList.map((item) => ({
          id: item.id,
          value: item.name,
          lon: item.coordinates.lon,
          lat: item.coordinates.lat
        }));
        return deepClone(sortDataArr);
      } else if (_selectedDataType === 'type1') {
        sortDataArr = dataList.map((item) => ({
          id: item.id,
          value: item.name,
          lon: item.coordinates.lon,
          lat: item.coordinates.lat
        }));
        return deepClone(sortDataArr);
      }
    },
    handleSelect(item) {
      // 处理选择输入建议的逻辑
      this.selectPoint = item;
      const map = getMap();
      map.setCenter([item.lon, item.lat]);
      map.setZoom(14);
    },
    // 模糊查询功能中,点击回到初始中心视口
    backCenter() {
      const map = getMap();
      map.setCenter([111.099259, 34.123574]);
      map.setZoom(9.6);
    },
    openCarMarkerLayer() {
      this.$emit('showCarMarker');
    },
    closeCarMarkerLayer() {
      this.$emit('hideCarMarker');
    }
  }
};
</script>

<style scoped>
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
#markerSearchBox {
  display: flex;
  flex-direction: row;
  justify-items: flex-start;
  align-items: center;
}
.dataTypeSelect {
  width: 150px;
  margin-right: 5px;
}
.searchSelectData {
  width: 200px;
}
.backCenterBtn {
  margin-left: 5px;
}
</style>
